import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import FilterSelect from './FilterSelect';
import { EXERCISE_TYPE_ICON } from '../../constants';

const ALL_TYPES_OPTION = {
  value: 'all-types', label: 'All Types', exerciseId: null, icon: 'lift',
};

const TYPE_SECTIONS = [
  { type: 'L', label: 'Lifts' },
  { type: 'R', label: 'SAQ+C' },
  { type: 'C', label: 'Circuits' },
  { type: 'H', label: 'Health' },
];

// "All Types" is only offered for a single athlete
const ExercisePicker = ({
  exercises, value, onChange, isLoading, allowAllTypes,
}) => {
  const options = useMemo(() => [
    ...(allowAllTypes ? [ALL_TYPES_OPTION] : []),
    ...TYPE_SECTIONS.map(({ type, label }) => ({
      label,
      options: exercises
        .filter((exercise) => exercise.type === type)
        .map((exercise) => ({
          value: String(exercise.id),
          label: exercise.name,
          exerciseId: exercise.id,
          icon: EXERCISE_TYPE_ICON[exercise.type] || 'lift',
        })),
    })).filter((section) => section.options.length > 0),
  ], [exercises, allowAllTypes]);

  const selectedOption = useMemo(() => {
    if (value === null) return allowAllTypes ? ALL_TYPES_OPTION : null;
    const flatOptions = options.flatMap((option) => option.options || option);
    return flatOptions.find((opt) => opt.exerciseId === value) || null;
  }, [options, value, allowAllTypes]);

  const handleChange = (option) => {
    onChange(option ? option.exerciseId : null);
  };

  return (
    <FilterSelect
      inputId='maxes-goals-exercise'
      ariaLabel='What to update'
      icon='lift'
      options={options}
      value={selectedOption}
      onChange={handleChange}
      isLoading={isLoading}
      isClearable={value !== null}
      placeholder='None'
      searchOverlayText='Search for an exercise'
      noOptionsMessage='No exercises found'
    />
  );
};

ExercisePicker.propTypes = {
  exercises: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    type: PropTypes.string,
  })),
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  allowAllTypes: PropTypes.bool,
};

ExercisePicker.defaultProps = {
  allowAllTypes: false,
  exercises: [],
  value: null,
  isLoading: false,
};

export default ExercisePicker;
